module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/feature_three-307e858e62a696f026d9e4fdcbb92d69.png";